var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSectionMethod(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3 13H9V11.5H3V13V13M3 10H9V8.5H3V10V10M1.5 16C1.08333 16 0.729167 15.8542 0.4375 15.5625C0.145833 15.2708 0 14.9167 0 14.5V1.5C0 1.08333 0.145833 0.729167 0.4375 0.4375C0.729167 0.145833 1.08333 0 1.5 0H8L12 4V14.5C12 14.9167 11.8542 15.2708 11.5625 15.5625C11.2708 15.8542 10.9167 16 10.5 16H1.5V16M7 5V1.5H1.5V1.5V1.5V14.5V14.5V14.5H10.5V14.5V14.5V5H7V5M1.5 1.5V1.5V5.4375V5.4375V1.5V5.4375V5.4375V14.5V14.5V14.5V14.5V14.5V14.5V1.5V1.5V1.5V1.5",
    fill: "#1D4ED8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionMethod);
export default __webpack_public_path__ + "static/media/section-method.c10c4ac49e85d5c9b680cd1367433dd0.svg";
export { ForwardRef as ReactComponent };